<template>
    <section>
        <SidebarComponent/>
        <transition name="slide-in">
            <SidebarServiceComponent v-show="$store.state.sidebarOpen"/>
        </transition>
        
        <main id="content" class="">
            <NavbarComponent/>
            <div id="page-content" class="grid text-left px-4 py-3">
                <div class="row">
                    <div class="col-12">
                        <AlertComponent/>
                    </div>
                </div>

                <slot/>
            </div>
        </main>
    </section>
</template>

<script>
    import NavbarComponent from "../NavbarComponent";
    import SidebarComponent from "../SidebarComponent";
    import AlertComponent from "../AlertComponent";
    import SidebarServiceComponent from "../SidebarServiceComponent";

    export default {
        name: "DefaultLayout",
        components: { AlertComponent, SidebarComponent, NavbarComponent, SidebarServiceComponent },
        
        data: function() {
            return {
                sidebarOpen: false
            }
            
        },
    }
</script>

<style scoped>
    main#content {
        flex-direction: column;
        width: calc(100% - 250px);
        margin-left: 250px;
    }
    div#page-content {
        margin-top: 48px;
    }

    .slide-in-enter-active {
        transition: all .3s ease;
    }
    .slide-in-leave-active {
        transition: all .3s ease;
    }
    .slide-in-enter, .slide-in-leave-to {
        margin-left: -250px;
    }
</style>